module.exports = __webpack_public_path__ + "static/media/m_sf_8.00e44b9c.png";